import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Cadastre } from '../../model/Cadastre';
import StringFormatter from '../../utility/StringFormatter';
import { evaluate } from '../../utility/Control';

const tagProperties: string[] = [
  'key',
  'municipality',
  'district',
  'establishedDate',
  'leasehold',
  'agriculturalCadastre',
  'zeroConcession',
  'specifiedArea'
];

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    const cadastre = DataStore.getCadastre();
    if (cadastre) {
      map(DataStore.getCadastre(), tag);
    }
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(cadastre: Cadastre, tag: any): void {
  tagProperties.forEach((tagProperty: string) => {
    tag[tagProperty] = undefined;
  });
  tag.key = StringFormatter.formatCadastreKey(cadastre.key);
  tag.municipality = cadastre.municipalityName;
  tag.district = evaluate(cadastre, 'address.cityDistrict');
  tag.establishedDate = evaluate(cadastre, 'establishedDate.ddmmyyyy');
  tag.leasehold = cadastre.leasehold;
  tag.agriculturalCadastre = cadastre.agriculturalCadastre;
  tag.zeroConcession = cadastre.zeroConcession;
  tag.specifiedArea = cadastre.specifiedArea;
}



/** WEBPACK FOOTER **
 ** ./src/components/cadastreDisplay/CadastreDisplayMapper.ts
 **/